import React, {createContext} from 'react';
import ReactDOM from 'react-dom';
import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import {Provider} from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import wordsReducer, {generateWordsState} from './reducers/words-reducer';
import gameModeReducer from './reducers/game-mode-reducer';
import usedLettersReducer from './reducers/used-letters-reducer';
import collectedLettersReducer from './reducers/collected-letters-reducer';
import pendingConfirmationReducer from './reducers/pending-confirmation-reducer';
import App from './App';

let level = parseInt(localStorage.getItem('level'), 10);
if (!level) {
    level = 1;
    localStorage.setItem('level', level);
    localStorage.setItem('This', 'is not the level you are looking for...');
}
const wordsInitialState = generateWordsState(level);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const gameReducers = combineReducers({
    words: wordsReducer,
    gameMode: gameModeReducer,
    usedLetters: usedLettersReducer,
    collectedLetters: collectedLettersReducer,
    pendingConfirmation: pendingConfirmationReducer,
});

const gameStore = createStore(
    gameReducers,
    {words: wordsInitialState},
    composeEnhancers(applyMiddleware(thunkMiddleware))
);

const rootElement = document.getElementById('root');
const render = () => {
    ReactDOM.render(
        <Provider store={gameStore}>
            <App />
        </Provider>,
        rootElement || document.createElement('div')
    );
};

render();

let msg = '%c Syrch a words search game made by Matti Bar-Zeev';
let styles = [
    'font-size: 12px',
    'font-family: monospace',
    'display: inline-block',
    'padding: 8px 19px',
    'border: 1px dashed;',
].join(';');
console.log(msg, styles);
